import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface PublicRoutesProps {
  children: JSX.Element | null;
}

const PublicRoute = ({ children }: PublicRoutesProps) => {
  const { pathname } = useLocation();
  useEffect(() => {
    setTimeout(() => {
      window?.HubSpotConversations?.widget?.remove();
    }, 900);
  }, [pathname]);

  return children;
};

export default PublicRoute;
